export enum NotificationTypeCode {
    OrganizationPendingStatus = 0,
    EventGroupInvitation = 1,
    EventGroupInviteAccepted = 2,
    EventGroupInviteDeclined = 3,
    EventSalesTaxAdjustment = 4,
    EventPayoutSuccessful = 5,
    EventPayoutFailed = 6,
}